module.exports = __webpack_public_path__ + "static/media/atom-editor.69a55f85.svg";